import React from "react";
import PolicyPageLayout, { PolicyList, PolicySection } from "./PolicyPageLayout";
import { COMPANY_DETAILS } from "./policyData";

const TermsAndConditions = () => {
  return (
    <PolicyPageLayout
      title="Terms & Conditions"
      subtitle={`By accessing ${COMPANY_DETAILS.website}, creating an account, placing an order, requesting a repair, or making a payment, you agree to these terms along with our Privacy Policy, Shipping Policy, Return Policy, Refund & Cancellation Policy, and Warranty Policy.`}
    >
      <PolicySection title="1. About Our Business and Website">
        <p>
          {COMPANY_DETAILS.name} operates this website for the sale of
          refurbished and pre-owned computers, accessories, and related repair
          or support services. Product listings, specifications, pricing and
          availability are subject to change without prior notice.
        </p>
      </PolicySection>

      <PolicySection title="2. Eligibility and Account Responsibility">
        <PolicyList
          items={[
            "You must provide accurate, current and complete information while placing orders or creating an account.",
            "You are responsible for maintaining the confidentiality of your account and login credentials.",
            "We may refuse service, suspend access or cancel suspicious transactions where details appear false, incomplete or fraudulent.",
          ]}
        />
      </PolicySection>

      <PolicySection title="3. Products, Services and Pricing">
        <PolicyList
          items={[
            "Refurbished or pre-owned products may show normal signs of previous use unless stated otherwise.",
            "Product images are for representation and may vary slightly based on model, batch, lighting or screen settings.",
            "Repair timelines, replacement options and compatibility depend on inspection, parts availability and technical feasibility.",
            "All prices are displayed in INR unless otherwise stated.",
          ]}
        />
      </PolicySection>

      <PolicySection title="4. Orders and Merchant Acceptance">
        <p>
          An order is considered accepted only after successful confirmation by
          our team and, where applicable, successful payment authorisation. We
          reserve the right to cancel or decline any order due to stock
          unavailability, pricing error, serviceability limitation, suspected
          fraud or technical failure.
        </p>
      </PolicySection>

      <PolicySection title="5. Payments and PhonePe">
        <p>
          Online payments may be processed through third-party payment partners,
          including PhonePe. Such payment partners only facilitate transaction
          processing. The sale contract for goods or services remains directly
          between you and {COMPANY_DETAILS.name}.
        </p>
        <PolicyList
          items={[
            "You authorise us to collect the amount shown at checkout, including applicable charges.",
            "We do not store your full card number, CVV, UPI PIN or OTP on our website.",
            "We may receive limited payment details such as transaction status, payment reference and merchant order reference for reconciliation and support.",
            "If your bank account is debited but order confirmation is delayed, please contact us with your order details and payment reference.",
            "Refunds, cancellations, product quality concerns and service complaints must be raised with us directly, not with the payment gateway alone.",
            "Any dispute relating to goods, services, delivery, returns or warranty must be resolved with us as the merchant.",
          ]}
        />
      </PolicySection>

      <PolicySection title="6. Shipping, Delivery and Service Scheduling">
        <p>
          Dispatch timelines, delivery estimates, pickup arrangements and repair
          commitments are governed by our Shipping Policy and the specific
          service communication shared with you by phone, email or WhatsApp.
        </p>
      </PolicySection>

      <PolicySection title="7. Returns, Cancellations, Refunds and Warranty">
        <p>
          Returns, refund approvals, cancellation requests and warranty claims
          are handled strictly according to our published policy pages. Please
          review those pages before placing an order or booking a service.
        </p>
      </PolicySection>

      <PolicySection title="8. User Conduct and Prohibited Use">
        <PolicyList
          items={[
            "You may not misuse the website, attempt unauthorised access, interfere with payment systems or engage in fraudulent activity.",
            "You may not upload false information, abusive content, malware or any material that violates applicable law.",
            "You may not copy, scrape or reuse our product content, designs or branding without written permission.",
          ]}
        />
      </PolicySection>

      <PolicySection title="9. Intellectual Property">
        <p>
          All website content including text, branding, design, layout,
          graphics, logos and source materials belongs to {COMPANY_DETAILS.name}
          or its licensors and may not be used without authorisation.
        </p>
      </PolicySection>

      <PolicySection title="10. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, we are not liable for indirect
          or consequential loss, including loss of data, profit or business, due
          to website downtime, delay, courier issues, third-party payment
          service interruptions, manufacturer defects or user misuse of products.
        </p>
      </PolicySection>

      <PolicySection title="11. Governing Law and Jurisdiction">
        <p>
          These terms are governed by the laws of India. Any dispute arising
          from website use, orders, payments or services will be subject to the
          courts located in {COMPANY_DETAILS.jurisdiction}.
        </p>
      </PolicySection>

      <PolicySection title="12. Customer Support and Contact Information">
        <PolicyList
          items={[
            `${COMPANY_DETAILS.name}`,
            `Email: ${COMPANY_DETAILS.email}`,
            `Phone: ${COMPANY_DETAILS.phone}`,
            `Address: ${COMPANY_DETAILS.address}`,
            `Support hours: ${COMPANY_DETAILS.supportHours}`,
          ]}
        />
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default TermsAndConditions;
